 <template>
      <el-dialog class="w-el-dialog" :visible.sync="visible" append-to-body title="请填写模板名称" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="Close">
            
            <el-form :model="form" label-width="120px" size="mini">

                
                <el-form-item label="模板名称">
                    <el-input v-model="form.name" placeholder="请输入模板名称" clearable></el-input>
                </el-form-item>

                <el-form-item label="状态">
                    <el-radio-group v-model="form.top">
                        <el-radio :label="0">不置顶</el-radio>
                        <el-radio :label="1">置顶</el-radio>
                    </el-radio-group>
                </el-form-item>

            </el-form>

            <span slot="footer">
                <el-button size="mini" @click="Close()">取 消</el-button>
                <el-button size="mini" type="primary" @click="TemplateEdit()" :loading="loading">确 定</el-button>
            </span>
      </el-dialog>
 </template>

 <script>
 export default {
    data () {
        return {
                        visible: false,
            loading: false,
            loadingText: null,

            form: {
                id: null,
                name: null,
                top: 0
            }
        }
    },

    methods: {
        Open (row) {
            this.form.id = row.id
            this.form.name = row.name
            this.form.top = row.top
            this.visible = true
        },
        Close() {
            this.loading = false
            this.visible = false
        },
        TemplateEdit() {
            this.loading = true
            this.$http.post('/9api/projects-template/edit', this.form).then(rps => {
                if (rps.data.state == 'success') {
                    this.$emit('onSave', rps.data.body)
                    this.Close()
                }
                this.loading = false
            })
        }
    }  
 }
 </script>